module.exports = __webpack_public_path__ + "img/shop-cart-icon.340d3a5a.svg";